<template>
  <div>
    <h1>컨텐츠 관리</h1>
    <div>
      <input type="text" placeholder="이름을 입력해 주세요" autofocus>
      <button>검색</button>
    </div>
    <div>
      <ul>
        <li>
          개발사(자)
        </li>
        <li>
          컨텐츠이름
        </li>
        <li>
          업로드일
        </li>
        <li>
          컨텐츠삭제
        </li>
      </ul>
      <ul>
        <li>
          안녕하
        </li>
        <li>
          용과같이
        </li>
        <li>
          A
        </li>
        <li>
          19. 07. 01
        </li>
        <li>
          <button>삭제</button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ManageContentsList.vue